import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eAnalysisRouteNames } from '../enums/route-names';

export const ANALYSIS_ROUTE_PROVIDERS = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService],
    multi: true,
  },
];

export function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/analysis',
        name: eAnalysisRouteNames.Analysis,
        iconClass: 'fas fa-book',
        layout: eLayoutType.application,
        order: 3,
      },
      {
        path: '/analysis/resource-type',
        name: eAnalysisRouteNames.ResourceTypes,
        layout: eLayoutType.application,
        order: 4,
        parentName: eAnalysisRouteNames.Analysis,
      },
      {
        path: '/analysis/resource',
        name: eAnalysisRouteNames.Resources,
        layout: eLayoutType.application,
        order: 5,
        parentName: eAnalysisRouteNames.Analysis,
      },
      {
        path: '/analysis/event-type',
        name: eAnalysisRouteNames.EventType,
        layout: eLayoutType.application,
        order: 6,
        parentName: eAnalysisRouteNames.Analysis,
      },
      {
        path: '/analysis/resource-event',
        name: eAnalysisRouteNames.ResourceEvent,
        layout: eLayoutType.application,
        order: 7,
        parentName: eAnalysisRouteNames.Analysis,
      },
      {
        path: '/analysis/stat',
        name: eAnalysisRouteNames.Stat,
        layout: eLayoutType.application,
        order: 8,
        parentName: eAnalysisRouteNames.Analysis,
      },
    ]);
  };
}
